<template>
  <div :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="更换手机号"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div class="mybox" :style="{ height: pageHeight+ 'px' }" style="margin-top:46px;">
      <p style="color:#A2A1A0;padding:20px 0;text-align: justify;">更换手机号后，下次登录可以使用新手机号登录。当前手机号：{{this.phoneNum}}</p>
      <van-form validate-first @failed="onFailed" @submit="onSubmit">
        <!-- 通过 pattern 进行正则校验 -->
        <van-field
          label="原手机号"
          v-model="phoneNum"
          name="pattern"
          :placeholder="phoneNum"
          readonly
        />
        <van-field
        v-model="phoneNumNew"
        center
        clearable
        label="新手机号"
        placeholder="请输入新手机号"
      >
        <!-- <template #button>
          <van-button size="small" type="info">发送验证码</van-button>
        </template> -->
      </van-field>
        <div style="margin: 16px 0;">
          <van-button  block type="info" native-type="submit">确定</van-button>
        </div>
      </van-form>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Form, Field } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Form, Field)

export default {
  name: 'changetelPage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field
  },
  created () {
    this.phoneNum = localStorage.getItem('phoneNum')
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)// 返回上一页面
    },
    onClickRight () {
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator (val) {
      // console.log(/^[1][3,4,5,7,8][0-9]{9}$/.test(val))
      // return /^[+]?(\d){1,3}[ ]?([-]?((\d)|[ ]){1,12})+$/.test(val)
    },
    onFailed (errorInfo) {
      // console.log('failed', errorInfo)
    },
    onSubmit () {
      // 不合法的手机号码
      if (!this.util.isPhoneNumber(this.phoneNum)) {
        this.util.toast('请输入正确原手机号')
        return
      }
      if (!this.util.isPhoneNumber(this.phoneNumNew)) {
        this.util.toast('请输入正确新手机号')
      }
      this.util.post('/updatePhoneNum', {
        phoneNum: this.phoneNumNew// 最新手机号
      }).then(({ data }) => {
        if (data.code === 200) {
          // 登录按钮执行登录的时候，存localStorage
          localStorage.setItem('isLogin', 1) // 存储已登录信息
          localStorage.setItem('UserToken', data.data.UserToken)
          this.util.toast(data.msg)
          localStorage.setItem('phoneNum', this.phoneNumNew) // 存储手机号
          this.$router.replace({
            path: '/login'// 返回登录页
          })
        } else {
          // 验证失败
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }
  },
  computed: {},
  data () {
    return {
      phoneNum: '', // 原手机号
      phoneNumNew: '', // 新手机号
      pattern: /^[+]?(\d){1,3}[ ]?([-]?((\d)|[ ]){1,12})+$/,
      pageHeight: window.innerHeight - 46
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #A6A6A6;
}

</style>
